var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarksearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7802 16.7192L12.6613 11.6003C13.6528 10.3755 14.2498 8.81923 14.2498 7.1242C14.2498 3.19561 11.0532 -0.000976562 7.12465 -0.000976562C3.19606 -0.000976562 -0.000488281 3.19557 -0.000488281 7.12416C-0.000488281 11.0528 3.1961 14.2493 7.12469 14.2493C8.81971 14.2493 10.376 13.6523 11.6008 12.6608L16.7196 17.7797C16.8659 17.9259 17.0579 17.9994 17.2499 17.9994C17.4419 17.9994 17.6339 17.9259 17.7802 17.7797C18.0734 17.4864 18.0734 17.0124 17.7802 16.7192ZM7.12469 12.7493C4.0226 12.7493 1.49956 10.2262 1.49956 7.12416C1.49956 4.02208 4.0226 1.49903 7.12469 1.49903C10.2268 1.49903 12.7498 4.02208 12.7498 7.12416C12.7498 10.2262 10.2267 12.7493 7.12469 12.7493Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarksearch);
export default __webpack_public_path__ + "static/media/darksearch.a587ccbaadba3482a5e84551b0a2b3b8.svg";
export { ForwardRef as ReactComponent };